module.exports = __webpack_public_path__ + "img/empty-rate-card.c34d7268.svg";